import React, { useState } from "react";
import { Popup } from 'witmeg-ui-system';
import "./HospitalityLoginModal.scss"
import close from "../../../../assets/close.svg"
import checked from "../../../../assets/checked-line.svg"
import config from 'react-global-configuration';
import jwt from 'jsonwebtoken';
import { DATA_VALIDATION_TYPES } from "../../../../../RestaurantWidget/utilities/helper/dataValidation";
import CustomInput from "../../../../components/CustomInput/CustomInput";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../../../utilities/helper";

const HospitalityLoginModal = ({ visibility, onPopupClose, setCustomerDetails, setIsCardPayment, useDeliveryForBilling, fromCheckout = false, setIsError }) => {
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [errors, setErrors] = useState({
        password: "",
        email: "",
    });
    const [isLoading, setIsLoading] = useState(false)
    const history = useHistory()
    const {
        selectedOrderType
    } = useSelector((state) => state.resturantData);
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        const newErrors = {
            password: "",
            email: "",
        };
        if (password.trim() === "") {
            newErrors.password = "*required";
            valid = false;
        }
        if (email.trim() === "") {
            newErrors.email = "*required";
            valid = false;
        } else if (!validateEmail(email)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };
    const handleClear = () => {
        setEmail("")
        setPassword("")
        setErrors({
            password: "",
            email: "",
        })
    }
    const handleSaveValues = (data) => {
        const userDetailsDelivery = localStorage.getItem('DELIVERY_DATA')
        let parsedUserDetailsDelivery = JSON.parse(localStorage.getItem('DELIVERY_DATA'))
        const address = data ? data.Addresses.find((address) => address.AddressType === "Billing") : null
        const addressDelivery = selectedOrderType === "delivery" ? userDetailsDelivery ? parsedUserDetailsDelivery.Addresses.find((address) => address.AddressType === "Delivery") : null : data ? data.Addresses.find((address) => address.AddressType === "Delivery") : null
        const defaultDetails = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) && JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA))

        const customerDetailsInitialState = {
            firstName: {
                value: data ? data.FirstName : "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_TEXT_ONLY],
            },
            lastName: {
                value: data ? data.LastName : "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_TEXT_ONLY],
            },
            mobileNo: {
                value: address ? address.Phone : '',
                hasError: false,
                errorType: null,
                errorMessage: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_PHONE_NO, DATA_VALIDATION_TYPES.IS_PHONE_NO_VALID],
            },
            emailAddress: {
                value: data ? data.Email : "",
                hasError: false,
                errorType: null,
                errorMessage: null,
                validations: [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_EMAIL],
            },
            customerAddress: {
                line1: {
                    value: useDeliveryForBilling ? addressDelivery?.AddressLine1 || "" : address ? address.AddressLine1 : '',
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: defaultDetails && defaultDetails.defaultOrderType === "table" ? [] : [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
                },
                line2: {
                    value: useDeliveryForBilling ? addressDelivery?.AddressLine2 || "" : address ? address.AddressLine2 : '',
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: [],
                },
                state: {
                    value: useDeliveryForBilling ? addressDelivery?.StateProvinceRegion || "" : address ? address.StateProvinceRegion : '',
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: defaultDetails && defaultDetails.defaultOrderType === "table" ? [] : [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
                },
                city: {
                    value: useDeliveryForBilling ? addressDelivery?.City || "" : address ? address.City : '',
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: defaultDetails && defaultDetails.defaultOrderType === "table" ? [] : [DATA_VALIDATION_TYPES.REQUIRED_FIELD],
                },
                postcode: {
                    value: useDeliveryForBilling ? addressDelivery?.PostZipCode || "" : address ? address.PostZipCode : '',
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: defaultDetails && defaultDetails.defaultOrderType === "table" ? [] : [DATA_VALIDATION_TYPES.REQUIRED_FIELD, DATA_VALIDATION_TYPES.IS_POSTCODE],
                },
                country: {
                    value: 'United Kingdom',
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: [],
                },
            },
            deliveryAddress: {
                line1: {
                    value: addressDelivery?.AddressLine1 || "",
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: [],
                },
                line2: {
                    value: addressDelivery?.AddressLine2 || "",
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: [],
                },
                state: {
                    value: addressDelivery?.StateProvinceRegion || "",
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: [],
                },
                city: {
                    value: addressDelivery?.City || "",
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: [],
                },
                postcode: {
                    value: addressDelivery?.PostZipCode || '',
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: [],
                },
                country: {
                    value: 'United Kingdom',
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: [],
                },
                instruction: {
                    value: '',
                    hasError: false,
                    errorType: null,
                    errorMessage: null,
                    validations: [],
                },
            },
        };
        setCustomerDetails(prev => ({
            ...prev,
            ...customerDetailsInitialState
        }));


    }
    const handleLogin = () => {

        const requestOptions = {
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                Authorization: `Bearer ` + config.get('LoginAuthorizationKey'),
            },
            body: JSON.stringify({ UserName: email, Password: password, OrganizationID: config.get('OrganisationID') })
        };
        fetch(config.get('API_URL_cust') + 'login', requestOptions)
            .then(response => response.json())
            .then(function (data) {
                if (data.Status === false) {
                    setIsLoading(false)
                    setIsError(true)
                    handleClear()
                    onPopupClose()
                }
                else {

                    localStorage.setItem("isLogged", "true")
                    const expireTime = new Date().getTime() + (config.get('CustjwtExp') * 1000)

                    var payload = {
                        "aud": config.get('CustjwtAud'),
                        "exp": expireTime,
                        "iss": config.get('CustjwtIss'),
                        "usertoken": data.Result.AccessToken
                    };

                    var signOptions = {
                        "algorithm": "RS256"
                    };

                    var privateKey = config.get('LoginprivateKey');
                    var token = jwt.sign(payload, privateKey, signOptions);

                    const requestUserDtlsOptions = {
                        method: 'POST',
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ` + token,
                        },
                        body: JSON.stringify({ "Email": email.toLowerCase(), "OrganizationID": config.get('OrganisationID') })
                    };

                    fetch(config.get('API_URL_cust') + 'fetch', requestUserDtlsOptions)
                        .then(response => response.json())
                        .then(function (data) {
                            if (data.Result) {

                                localStorage.setItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID, data?.Result?.UserID);
                                localStorage.setItem('fullUserDetails', JSON.stringify(data.Result));
                                if (fromCheckout) {
                                    handleSaveValues(data.Result)
                                    setIsCardPayment(data.Result.DefaultPaymentType === "Card")
                                }
                                handleClear()
                                setIsLoading(false)
                                onPopupClose()
                                if (!fromCheckout) {
                                    window.location.href = '/'
                                }
                            }
                        });


                }
            })

    };
    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };

    return (
        <Popup
            className='HospitalityLoginModal'
            modalVisible={visibility}
            modalTitle=""
            mask={true}
            centered
            onCancel={() => {
                handleClear()
                onPopupClose()
            }}
            closable={false}>
            <div className="modal-inner">
                <div className="modal-inner-header-container">
                    <div className="modal-inner-header-wrapper">
                        <div className="modal-inner-title-text">
                            Login to Your Account
                        </div>
                        <img className="close-icon" alt="" src={close}
                            onClick={() => {
                                handleClear()
                                onPopupClose()
                            }} />
                    </div>
                    <div className="modal-inner-sub-text">Access your saved addresses and payment methods</div>
                </div>
                <div className="modal-inner-input-container">
                    <div className="input-conti-wrapper">
                        <CustomInput
                            onChange={(e) => {
                                setEmail(e.target.value);
                                handleChange("email")
                            }}
                            type="text"
                            value={email}
                            error={errors.email !== ""}
                            errorText={errors.email}
                            label={"Email Address"}
                            required
                            icon={"email"}
                            placeholder={"Enter your email address"}
                        />
                    </div>
                    <div className="input-conti-wrapper">
                        <CustomInput
                            onChange={(e) => {
                                setPassword(e.target.value);
                                handleChange("password")
                            }} type="password" value={password} error={errors.password !== ""}
                            label={"Password"}
                            required
                            icon={"lock"}
                            placeholder={"Enter your password"}
                            errorText={errors.password}

                        />
                    </div>
                    <div className="login-btn-cont"
                        onClick={() => {
                            if (validateForm() && !isLoading) {
                                setIsLoading(true)
                                handleLogin()
                            }
                        }}>{isLoading && <div className="loader-btn" />}Login</div>
                    <div className="or-content">
                        <div className="line-ocnt" />
                        <div className="or-text">OR</div>
                        <div className="line-ocnt" />

                    </div>
                    <div className="creat-btn-cont"
                        onClick={() => {
                            handleClear()
                            onPopupClose()
                            history.push("/account/register")
                        }}>Create New Account</div>
                    <div className="guest-text" onClick={() => {
                        handleClear()
                        onPopupClose()
                    }} >
                        Continue as guest instead
                    </div>
                </div>
                <div className="modal-inner-bottm-modl-cont">
                    <div className="bene-header">Account Benefits:</div>
                    <div className="bene-text"> <img alt="" src={checked} />Save multiple delivery addresses</div>
                    <div className="bene-text"> <img alt="" src={checked} />Securely store payment methods</div>
                    <div className="bene-text"> <img alt="" src={checked} />Track order history and reorder favorites</div>
                    <div className="bene-text">
                        <img alt="" src={checked} />Earn rewards and exclusive offers</div>
                </div>
            </div>
        </Popup>
    )
}
export default HospitalityLoginModal